module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    staticClass: "smart",
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 70
    }
  }, [(_vm.testResult.id) ? _vm._l((_vm.blocks), function(block, index) {
    return _c('Block', {
      key: index,
      attrs: {
        "title": block.title,
        "description": block.description,
        "id": _vm.id,
        "data": block.data,
        "method": block.method,
        "service": "smart",
        "type": block.key,
        "isOpened": block.key === "professions"
      }
    })
  }) : _c('Warning', [_c('p', [_c('b', [_vm._v("Приглашаем вас принять участие в профориентационном тестировании, чтобы вы смогли получить полезную информацию,рекомендованную именно вам!")])]), _c('p', [_vm._v("Тест-игра разработана специально для нашей платформы и основана на методике доктора педагогических наук, профессора МГУ Пряжникова Н.С.,авторитетного отечественного специалиста в области профессионального самоопределения.")]), _c('p', [_vm._v("По результатам прохождения тест-игры в этом разделе вам будут рекомендованы\nнаиболее подходящие профессии и компетенции, в соответствии с которыми будут подобраны программы,\nопубликованные в Каталоге программ. Кроме того, будут предложены для ознакомления актуальные и интересные статьи,\nинтервью со специалистами и видео, которые помогут узнать больше об этих профессиях и компетенциях.")]), _c('p', {
    staticClass: "alert bold"
  }, [_vm._v("ОБРАТИТЕ ВНИМАНИЕ!")]), _c('p', {
    staticClass: "bold"
  }, [_vm._v("Для прохождения тест-игры вам необходимо выбрать ответы из списка значений и нажатием и удержанием левой кнопки\nмыши перетащить их ВЛЕВО или ВПРАВО в зависимости от того, нравится вам ответ или нет.")])]), _c('IntalentTest', {
    attrs: {
      "iframeSrc": _vm.iframeSrc
    },
    on: {
      "completed": _vm.onCompleted
    },
    model: {
      value: (_vm.process),
      callback: function($$v) {
        _vm.process = $$v
      },
      expression: "process"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3f01cb","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/career-guidance/components/smart/Smart.vue
// module id = 8efe04b34071308884ea
// module chunks = 4